import { SSPageDataLayerObject } from "@pages/ShieldStarter/DataLayer/DataLayer.model";
import { get } from "lodash";


export class DSPageDataLayerObject extends SSPageDataLayerObject{}

export class DSUserDataLayerObject {
  person={
    age:""
  }
  constructor(data: any){
    this.person = get(data, "person", {
      age: "",
    });
  }
}

export class DSAcquisitionDataLayerObject {
  insurance = {
    paymentOptions: "",
    paymentMethod: "",
    premium: "",
    coverAmount: "",
    premiumTerm: "",
    monthlyPayout: "",
  };
  customer = {
    marketingOptIn: "",
    DOB: "",
  };
  product = {
    prodName: "",
    prodID: "",
    premiumfrequency: "",
    policyID:""
  };

  constructor(data: any) {
    this.customer = get(data, "customer", {
      DOB: "",
      marketingOptIn: "",
    });

    this.product = get(data, "product", {
      premiumfrequency: "",
      prodID: "",
      prodName: "",
      policyID:""
    });

    this.insurance = get(data, "insurance", {
      paymentOptions: "",
      paymentMethod: "",
      premium: "",
      coverAmount: "",
      premiumTerm: "",
      monthlyPayout: "",
    });
  }
}
// digitalData.form.field.Gender
// digitalData.form.error.fieldLabels
// digitalData.form.error.messages
// digitalData.form.error.numErrors
// digitalData.form.name

export class DSFormDataLayerObject {
  name=""
  field={
    Gender: ''
  }
  error={
    fieldLabels:[],
    messages:[],
    numErrors:"0"
  }

  constructor(data: any) {
    this.name = get(data, "name", "");
    this.field =  get(data, 'field', {Gender:""})
    this.error = get(data, 'error', {fieldLabels:[], messages:[], numErrors:0})
  }
}


export class DSDataLayer {
  public page: DSPageDataLayerObject;
  public acquisition: DSAcquisitionDataLayerObject;
  public form: DSFormDataLayerObject;
  public user: DSUserDataLayerObject;
  constructor(initialData: any) {
    this.page = get(initialData, "page", {});
    this.acquisition = get(initialData, "acquisition", {});
    this.form = get(initialData, "form", {});
    this.user = get(initialData, 'user',{})
  }
}

